import { inject, Injectable } from '@angular/core';
import { RoutingService } from '@spartacus/core';
import { CurrentProductService } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
@Injectable({
  providedIn: 'root',
})
export class KbCurrentProductService extends CurrentProductService {
  routing = inject(RoutingService);
  protected override getCode(): Observable<string> {
    return this.routing
      .getRouterState()
      .pipe(map((state) => {
        const productCode = state.state.params['productCode'];
        return productCode ? productCode.toString().toUpperCase() : '';

      }));
  }
}
